export default __webpack_public_path__ + "static/media/vicop07.f0a8dc1e.jpg";